import React, { useEffect, useState } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { ProductDetailProps } from './product-detail';
import help from './product-detail.help';

import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import productDetailMasterColumns from '../../types/productDetailType';
import notification from '@plasma/ui.feedback.notification';
import { ProfileDetail, Product, ProductGroup } from '../../types/dataTypesForProdDetails';
import { isTypedArray } from 'util/types';
import { deleteDataFromApiWithBody } from '../../services/Deletes/deleteData';
import { apiUriMasterDataHttp } from '../../services/conf/apiConf';


function useProductDetailHook(props: ProductDetailProps) {
  useResourceBundle(translations, undefined, 'a310d62d-9aea-4d88-ae25-e943b8f275cb');
  useHelpBundle(help);

  const { t } = useTranslation();
  const [profile, setprofile] = useState<any>();
  const [dataForColumns, setdataForColumns] = useState([]);
  const [columnNames, setcolumnNames] = useState(productDetailMasterColumns());
  const [dataToShowInCard, setdataToShowInCard] = useState([]);
  const [finalDataToShowInCard, setfinalDataToShowInCard] = useState();
  const [distinctProdName, setdistinctProdName] = useState([]);
  const [ModalVisible, setModalVisible] = useState(false);
  const [modalTitle, setmodalTitle] = useState('');
  const [dataToLoadInEditMode, setdataToLoadInEditMode] = useState({});
  const [isFormVisible, setisFormVisible] = useState(false);

  const [productId, setproductId] = useState("");
  const [productType, setproductType] = useState("");
  const [productCode, setproductCode] = useState("");
  const [productDescription, setproductDescription] = useState("");
  const [isActive, setisActive] = useState(false);
  const [remarksInModal, setremarksInModal] = useState("");
  const [roleID, setroleID] = useState<number | null>(null);


  useEffect(() => {
    if (!roleID) {
      const storedData = sessionStorage.getItem('roleid');
      if (storedData) {
        setroleID(JSON.parse(storedData));
      }
    }
  }, [roleID]);


  useEffect(() => {
    fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()).then((data) => {
      //set the response
      setdataForColumns(data);
      setdataToShowInCard(data);

    }).catch((error)=>{

    });
  },[]);

  //console.log(dataToShowInCard);

  useEffect(() => {
    // const allProductType = dataToShowInCard?.map((oneType)=> oneType.producttype);
    // const distProdName = allProductType?.filter((value, index, self) => self.indexOf(value) === index);

    // setdistinctProdName(distProdName);

    const groupedProducts: { [key: string]: ProfileDetail[] } = {};

    // Group products by product type
    dataToShowInCard?.forEach((product) => {
        if (!groupedProducts[product.producttype]) {
            groupedProducts[product.producttype] = [];
        }
        groupedProducts[product.producttype].push({
            productcode: product.productcode,
            productdescription: product.productdescription
        });
    });

    // Construct the desired structure
    const result: ProductGroup[] = Object.keys(groupedProducts)?.map((type) => {
        return {
            producttype: type,
            profileDetail: groupedProducts[type]?.map((detail) => ({
                productcode: detail.productcode,
                productdescription: detail.productdescription
            }))
        };
    });

    result.forEach(element => {
      element.isHovered = false;
    });

    setfinalDataToShowInCard(result);

  },[dataToShowInCard]);

  //console.log('CardData List: ', finalDataToShowInCard);


  const handleSaveFromModal = () =>{

    const jsontoSend = {
                          productid: productId,
                          productcode: productCode,
                          producttype: productType,
                          displayseq: 0,
                          productdescription: productDescription,
                          isactive: isActive,
                          remarks: remarksInModal
                       };

    //console.log(jsontoSend);

    sendAllDataPost_byApiNameAndData('AddMasterProductProfile', jsontoSend, apiUriMasterDataHttp())
      .then((response) => {
        if(response){
          fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()).then((data) => {
            setdataToShowInCard(data);
            notification.success('Success !', 'Data Saved Successfully', undefined, 'medium', 3)
          }).catch((error)=>{
            console.log("Failed to EditPlantLayout");
          });
        }
      }).catch((error) => {
        console.log(error);
        notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
      });

    HandleModalCancel();

  };

  const handleDeleteFromModal = () => {

    const jsontoSend = {
      productid: productId,
      productcode: productCode,
      producttype: productType,
      displayseq: 0,
      productdescription: productDescription,
      isactive: isActive,
      remarks: remarksInModal ? remarksInModal : ""
    };

    //console.log(jsontoSend);

    deleteDataFromApiWithBody('DeleteMasterProductProfile', jsontoSend, apiUriMasterDataHttp())
      .then((response) => {
        if(response){
          fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()).then((data) => {
            setdataToShowInCard(data);
            notification.success('Removed !', 'Data Deleted Permanently', undefined, 'medium', 3)
          }).catch((error)=>{
            console.log("Failed to EditPlantLayout");
          });
        }
      }).catch((error) => {
        console.log(error);
        notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
      });

      HandleModalCancel();
  };

  const handleSetBoolean = (cardINdex: number, DidMouseEnter: boolean) => {
    const DatatoShowONCard = finalDataToShowInCard.map((item, index) => {
      if(index === cardINdex && DidMouseEnter){
        item.isHovered = true;
      }
      else{
        item.isHovered = false;
      }
      return item;
    })
    setfinalDataToShowInCard(DatatoShowONCard);
  };

  const handleEdit = (itemToEdit) =>{
    setmodalTitle(`${t("edit")} ${t("profile")} ${t("from")} ${itemToEdit.producttype}`);
    setdataToLoadInEditMode(itemToEdit);
    setModalVisible(true);
  };

  const handleProfileChange = (value: string) => {
    setprofile(value);

    // const prodType = (dataToShowInCard?.filter((oneData)=> oneData.productcode === value))?.map((item)=> item.producttype);

    const product = dataToShowInCard.find(prod => prod.productcode === value);

    if (product) {
      const { productid, productdescription, productcode, producttype, remarks, isactive } = product;

      setproductId(productid);
      setproductType(producttype);
      setproductCode(productcode);
      setproductDescription(productdescription);
      setremarksInModal(remarks);
      setisActive(isactive);

    } else {
      return null; // or handle the case when the product is not found
    }

    setisFormVisible(true);

  };

  const HandleSaveFamilyFromModal = () => {

  };

  const HandleModalCancel = () => {
    setdataToLoadInEditMode({});
    setisFormVisible(false);
    setprofile(null);
    setmodalTitle('');
    setproductId('');
    setproductType('');
    setproductCode('');
    setproductDescription('');
    setremarksInModal('');
    setisActive(false);
    setModalVisible(false);
  };

  const handleVisibilityModal = () => {
    setmodalTitle('Create A New Profile');
    setisFormVisible(true);
    setModalVisible(true);
  };

  const handleproductTypeChange = (event: React.ChangeEvent<HTMLInputElement>) =>{
    const blockProdType = event.target.value.toUpperCase();
    setproductType(blockProdType);
  };

  const handleproductCodeChange = (event: React.ChangeEvent<HTMLInputElement>) =>{
    setproductCode(event.target.value);
  };

  const handleproductDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) =>{
    setproductDescription(event.target.value);
  };

  const handleSwitchChange = (checked: boolean) => {
    setisActive(checked);
    //console.log(checked);
  };

  const handleremarksChange = (event: React.ChangeEvent<HTMLInputElement>) =>{
    setremarksInModal(event.target.value);
  };


  return {
    t,
    dataForColumns,
    columnNames,
    dataToShowInCard,
    distinctProdName,
    finalDataToShowInCard,
    modalTitle,
    ModalVisible,
    profile,
    dataToLoadInEditMode,
    productType,
    productCode,
    productDescription,
    isActive,
    remarksInModal,
    isFormVisible,
    roleID,
    handleSaveFromModal,
    handleDeleteFromModal,
    handleSetBoolean,
    handleEdit,
    HandleModalCancel,
    HandleSaveFamilyFromModal,
    handleProfileChange,
    handleVisibilityModal,
    handleproductTypeChange,
    handleproductCodeChange,
    handleproductDescriptionChange,
    handleSwitchChange,
    handleremarksChange
  };
}

export default useProductDetailHook;
